import { useLocation } from "react-router";

/** Visually hidden h1 on catalog routes (Zudoku catalog only renders a level-2 heading). */
export const CatalogMainHeading = () => {
  const { pathname } = useLocation();
  const isCatalog =
    pathname === "/catalog" || pathname.startsWith("/catalog/");

  if (!isCatalog) {
    return null;
  }

  return <h1 className="sr-only">API Catalog</h1>;
};
